import React, { useState } from 'react';
import AdminLayout from './AdminLayout';
import FeatureMapInfo from './FeatureMapInfo';
import Companies from './Companies';
import DataManagement from './DataManagement';
import Prompts from './Prompts';
import Dimensions from './Dimensions';
import Users from './Users';
import ProductDetails from './ProductDetails';

const FeatureGroupAdmin = ({ featureGroupId, featureGroupName, featureGroupDescription, onUpdate, userRole }) => {
  const [activePanel, setActivePanel] = useState('info');

  return (
    <AdminLayout
      featureGroupId={featureGroupId}
      featureGroupName={featureGroupName}
      featureGroupDescription={featureGroupDescription}
      userRole={userRole}
      onUpdate={onUpdate}
      activePanel={activePanel}
      onPanelChange={setActivePanel}
    >
      <FeatureMapInfo
        panelId="info"
        featureGroupId={featureGroupId}
        featureGroupName={featureGroupName}
        featureGroupDescription={featureGroupDescription}
        onUpdate={onUpdate}
      />
      <UsersPanel
        panelId="users"
        featureGroupId={featureGroupId}
        userRole={userRole}
      />
      <CompaniesPanel
        panelId="companies"
        featureGroupId={featureGroupId}
      />
      <DimensionsPanel
        panelId="dimensions"
        featureGroupId={featureGroupId}
        userRole={userRole}
      />
      <PromptsPanel
        panelId="prompts"
        featureGroupId={featureGroupId}
        userRole={userRole}
      />
      <ProductDetailsPanel
        panelId="product-details"
        featureGroupId={featureGroupId}
        userRole={userRole}
      />
      <DataManagementPanel
        panelId="data"
        featureGroupId={featureGroupId}
      />
    </AdminLayout>
  );
};

// Wrapper components for each panel
const UsersPanel = ({ panelId, featureGroupId, userRole }) => (
  <div data-panel-id={panelId} style={{ padding: 0 }}>
    <Users featureGroupId={featureGroupId} userRole={userRole} />
  </div>
);

const CompaniesPanel = ({ panelId, featureGroupId }) => (
  <div data-panel-id={panelId} style={{ padding: '24px' }}>
    <Companies featureGroupId={featureGroupId} />
  </div>
);

const DimensionsPanel = ({ panelId, featureGroupId, userRole }) => (
  <div data-panel-id={panelId} style={{ padding: '24px' }}>
    <Dimensions featureGroupId={featureGroupId} userRole={userRole} />
  </div>
);

const PromptsPanel = ({ panelId, featureGroupId, userRole }) => (
  <div data-panel-id={panelId} style={{ padding: '24px' }}>
    <Prompts featureGroupId={featureGroupId} userRole={userRole} />
  </div>
);

const ProductDetailsPanel = ({ panelId, featureGroupId, userRole }) => (
  <div data-panel-id={panelId} style={{ padding: 0 }}>
    <ProductDetails featureGroupId={featureGroupId} userRole={userRole} />
  </div>
);

const DataManagementPanel = ({ panelId, featureGroupId }) => (
  <div data-panel-id={panelId} style={{ padding: '24px' }}>
    <DataManagement featureGroupId={featureGroupId} />
  </div>
);

export default FeatureGroupAdmin;

